import { AidaDescription } from 'entities/application/constants/applications/AIDA/Aida_Description';
import { AidaInstruction } from 'entities/application/constants/applications/AIDA/AidaInstruction';
import { aidaPlans } from 'entities/application/constants/applications/AIDA/AidaPlans';
import { ApplicationWithDetails } from '../../../types';

export const Aida: ApplicationWithDetails = {
	id: `11ECF3AAF97D059CB9706F21406EBD11`,
	name: `Aida`,
	description: `Команда опытных управленцев, аналитиков и разработчиков для удаленного решения\nежедневных задач у вас в кармане.`,
	descriptionCard: `Команда опытных управленцев у вас в кармане.`,
	descriptionHTML: AidaDescription,
	logoUrl: `https://cdn.dodostatic.net/static/marketplace/aida/logo-n`,
	logoBgr: `https://cdn.dodostatic.net/static/marketplace/aida/bgr`,
	sliders: [
		`https://cdn.dodostatic.net/static/marketplace/aida/slider-1-new`,
		`https://cdn.dodostatic.net/static/marketplace/aida/slider-2-new`,
		`https://cdn.dodostatic.net/static/marketplace/aida/slider-3-new`,
		`https://cdn.dodostatic.net/static/marketplace/aida/slider-4-new`,
	],
	webSiteUrl: `https://uk-vkus.ru/`,
	supportUrl: null,
	redirectUrl: ``,
	contactEmail: `Телеграм-чат`,
	supportEmail: `https://t.me/+TSY5w7zNctg4NzBi`,
	categories: [`Уведомления`, `Мониторинг производства`, `Обратная связь`, `Клиенты`],
	countries: [`Все`],
	languages: [`Русский`],
	conceptions: [`Dodo Pizza`, `Drinkit`, `Doner42`],
	price: `Бесплатно`,
	version: `1.0`,
	type: `Бот`,
	developer: `УК Вкус`,
	plans: aidaPlans,
	instructions: AidaInstruction,
	details: null,
	knowledgeBase: null,
	isExternal: true,
	showInstruction: false,
	versionHistory: `https://aidaupdate.kaiten.site`,
	goToApp: true,
};
